module.exports = __webpack_public_path__ + "static/media/check.60820084.svg";